var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlWirelessInternetFilled = function SvgHtlWirelessInternetFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 12.5a.75.75 0 1 1 1.499 0 .75.75 0 0 1-1.5 0Zm-1.945-1.9a.748.748 0 0 1 .177-1.046 4.356 4.356 0 0 1 5.039 0 .75.75 0 0 1-.869 1.223 2.852 2.852 0 0 0-3.3 0 .745.745 0 0 1-.778.056.749.749 0 0 1-.269-.233ZM3.222 8.509a.75.75 0 0 1 .1-1.056 7.35 7.35 0 0 1 9.41 0 .75.75 0 1 1-.956 1.152 5.85 5.85 0 0 0-7.49 0 .747.747 0 0 1-.48.174.75.75 0 0 1-.586-.27h.002ZM1.087 6.395a.75.75 0 0 1 .067-1.058 10.349 10.349 0 0 1 13.69 0 .75.75 0 0 1-.99 1.125 8.868 8.868 0 0 0-11.707 0 .749.749 0 0 1-1.06-.067Z"
  })));
};
export default SvgHtlWirelessInternetFilled;